export const selectedThirdPartyPartner = state => state.selectedThirdPartyPartner


// WEBPACK FOOTER //
// ./src/store/modules/thirdparty/getters.js